import { Component, ChangeDetectionStrategy } from '@angular/core';
import { User } from '../../shared.interfaces';
import { UserService } from '../../services/user.service';
import { DialogService } from '../../services/dialog.service';
import { environment } from '../../../../environments/environment';
import { IDialog } from '../../directives/dialog.directive';

@Component({
    selector: 'app-user-profile',
    templateUrl: './user-profile-modal.component.html',
    styleUrls: ['./user-profile-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserProfileModalComponent implements IDialog<User> {
    constructor(private userService: UserService, public dialogService: DialogService) {}

    data: User;

    get user(): User {
        return this.data;
    }

    signOut() {
        this.userService.logout();
    }

    openLegal() {
        window.open(environment.legalUrl);
    }
}
